module.exports = __webpack_public_path__ + "img/whatsapp-background.d6edcff0.svg";